<div
	class="ngx-rich-text"
	[ngClass]="{
		'toolbar-below': toolbarBelow === 'withBorder',
		'toolbar-below-no-top-border': toolbarBelow === 'withoutBorder',
		'toolbar-extra-below': toolbarBelow === 'extra'
	}">
	@if (hugerteOptions) {
		<editor
			[attr.id]="uniqueId"
			[init]="hugerteOptions"
			(onBlur)="blurHandler($event)"
			(onFocus)="focusHandler($event)"
			(onFocusOut)="focusOutHandler()"
			(onInit)="initHandler($event)"
			(onKeyUp)="keyupHandler($event)"
			(onKeyDown)="keydownHandler($event)"
			[(ngModel)]="editorContent"
		></editor>
	}
</div>
